import { webSocket, WebSocketSubject } from 'rxjs/webSocket';
import { environment } from '../../environments/environment';
import { share, retryWhen, tap, mergeMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { TopicType } from '../enums/topic-type';
import { v4 as uuid } from 'uuid';
import { timer } from 'rxjs';

const wsKafkaUrl = environment.wsBaseUrl;

@Injectable({ providedIn: 'platform' })
export class WebSocketService {
  private socket: WebSocketSubject<any> = webSocket({
    url: wsKafkaUrl,
    protocol: ['wss', 'ws'],
  });
  private _uuid = uuid();
  get uuid() {
    return this._uuid;
  }

  initConnection() {
    return this.socket.pipe(
      retryWhen((errors) =>
        errors.pipe(
          tap((err) => {
            console.warn('Web socket connection error:', err.message);
          }),
          mergeMap(() => timer(2000)),
        ),
      ),
    );
  }

  public messages$ = this.socket.pipe(share());
  //TODO manipulate with uuid storage
  send({
    topic,
    message,
    regenerateUuid = false,
  }: {
    topic: TopicType;
    message: object;
    regenerateUuid?: boolean;
  }) {
    this.socket.next({
      topic,
      ...message,
      key: regenerateUuid ? uuid() : this.uuid,
    });
  }
}
